<template>
  <div class="chart-line q-mb-md">
    <LineChartGenerator
      ref="line"
      :chart-options="chartOptions"
      :chart-data="chartData"
      chart-id="line-chart"
      dataset-id-key="label"
      :plugins="plugins"
    />
  </div>
</template>

<script>
import { Line as LineChartGenerator } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
)

export default {
  name: 'LineChart',
  components: {
    LineChartGenerator
  },
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartData: {
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            borderColor: 'rgb(75, 192, 192)',
            tension: 0.5,
            pointRadius: 0,
            pointHoverRadius: 0
          }
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              maxTicksLimit: 5
            }
          },
          x: {
            ticks: {
              maxTicksLimit: 5,
              display: false
            }
          }
        }
      },
      plugins: [{
        id: 'customScale',
        beforeDatasetsDraw(chart, args, pluginOptions) {
          const { ctx, chartArea: { top, bottom, left, right, width, height }, scales: {x, y} } = chart;

          const nbElement = x.ticks.length
          const maxTicks = nbElement > 4 ? 4 : nbElement
          let tickNb = 0
          const modulo = Math.floor(nbElement/(maxTicks+2))
          ctx.save()
          for(var i=0; i<x.ticks.length; i++) {
            if(/*i > 0 &&*/ i < x.ticks.length - 1 && i%modulo == 0 /*&& tickNb < maxTicks*/) {
              tickNb ++
              ctx.fillStyle = "rgb(88,88,88)"
              const date = new Date(x.ticks[i].label)
              const minutes = date.getMinutes() > 9 ? date.getMinutes() : `0${date.getMinutes()}`
              ctx.fillText(`${date.getHours()}:${minutes}`, x.getPixelForValue(x.ticks[i].value), bottom)
            }
          }
        }
      }]
    }
  },
  watch: {
    // à chaque fois que la question change, cette fonction s'exécutera
    data: function (newData, oldData) {
      this.$set(this.chartData.datasets[0], 'data', newData)
      this.$refs.line.updateChart()
    }
  },
}
</script>
<style>
.chart-line {
  border-left: 2px solid rgb(199,198,198);
  border-bottom: 2px solid rgb(199,198,198);
}
</style>